import { render } from "./MentionDialog.vue?vue&type=template&id=16576ad4&scoped=true"
import script from "./MentionDialog.vue?vue&type=script&lang=js"
export * from "./MentionDialog.vue?vue&type=script&lang=js"

import "./MentionDialog.vue?vue&type=style&index=0&id=16576ad4&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16576ad4"]])

export default __exports__